import { useRef, useEffect, useCallback } from 'react'

export const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export const useHookWithRefCallback = () => {
  const ref = useRef(null)
  const setRef = useCallback(node => {
    ref.current = node
  }, [])

  return [ref, setRef]
}
